import { BehaviorSubject } from "./behavior-subject";

export class MapOfBehaviorSubjects<K,V>{
	public constructor(
		private readonly defaultValue:((k:K)=>V)
	){
	}

	private readonly map=new Map<K,BehaviorSubject<V>>();

	public get(k:K){
		let v=this.map.get(k);
		if(!v){
			v=new BehaviorSubject<V>(this.defaultValue(k));
			this.map.set(k,v);
		}
		return v;
	}

	public complete(){
		for(const v of this.map.values())
			v.complete();
	}

	public values(){
		return this.map.values();
	}
}
